










































































  
	/* eslint-disable @typescript-eslint/camelcase */ 
    import axios from 'axios';
	import {   controleService }  from '@/servicegerente';

	import {Watch, Component, Vue } from 'vue-property-decorator'; 
	  
	@Component({
		components: {  },
	 })
    export default class TipoReferenciaCadastro extends Vue {

		public url: any = null;
		public ano: any = null;  
		public texto: any = null;  
		public init: any = null; 
		public page: any = null; 
		public token: any = null;  
		public processar = false; 
		public index = 0; 
		 
		public urlRetorno: any= '/v2/administracao/configuracao'; 
		public errors: any = { };

        delay(ms: number) {
            return new Promise( resolve => setTimeout(resolve, ms) );
        }
		 
        async buscarCEP( ) {  
			if( !this.token || !this.url ){
				return;
			}
			this.index = 0; 
			const header = {headers:  { 'Authorization': 'Bearer ' +  this.token  } }; 
            for (this.index  = parseInt( this.init ) ; this.index  <= parseInt( this.page ) ; this.index ++) { 
                axios.get( this.url +  this.index  ,  header  )
                .then(response => {   
                    this.texto = response.data.data.rows;
                    this.salvar();
                })
                .catch(error => { 
                    console.log(error);
                })  
				if(this.index %5===0 && this.processar  ){
					this.processarImport(); 
				}
                await this.delay(8000); 
            }
            await this.processarImport(); 
            await this.processarImport(); 
            await this.processarImport(); 
        }  
		 

		salvar() {
			window.alertProcessando();
			const dados = {
				texto : this.texto,
				ano :this.ano,   
			};   
			controleService.inserirImport(   dados  )
			.then(response => {
				window.toastSucesso(response);  
				window.alertProcessandoHide(); 
			})
			.catch(error => {  
				window.alertProcessandoHide();
				this.errors = error.data.error; 
				console.log(error);
			});  
		} 
 
        public async processarImport( ) {  
            controleService.processaImport(   )
			.then(response => { 
				window.toastSucesso('processarImport realizada com sucesso!!' , response  ); 
			})
			.catch(error => {  
				window.toastErro('Não foi possivel processarImport ' , error.data); 
			});  
        }

	}
 
